var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white h-full"},[_c('iframe-loader',{attrs:{"url":_vm.link}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }